<div *ngIf="showProject" class="requirements-ack__section">
  <h3>Project Requirements</h3>
  <div class="special-request-notes">{{ projectRequirements }}</div>
</div>

<div *ngIf="showSiteSection" class="requirements-ack__section">
  <h3>Site Requirements</h3>
  <div class="special-request-notes">{{ siteRequirements }}</div>
</div>

<ng-container *ngIf="requiresAcknowledgement">
  <hr class="requirements-ack__divider" />
  <label class="requirements-ack__checkbox">
    <input
      type="checkbox"
      data-testid="requirements-ack-acknowledge"
      [(ngModel)]="acknowledged"
      (ngModelChange)="acknowledgedChange.emit($event)"
    />
    <span>{{ labelText }}</span>
  </label>
</ng-container>
